import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/client';
import B2BTheme, { EPRTheme, ExchangeTheme } from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { App } from './App';
import { getRoutes } from './routes';

NewRelicBridge.init();
// whyDidYouRender.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  if (client.serverData.themeName === 'epr') {
    client.setTheme({ name: 'epr', template: EPRTheme });
  } else if (client.serverData.themeName === 'exchange') {
    client.setTheme({ name: 'exchange', template: ExchangeTheme });
  } else if (client.serverData.themeName === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  client.render(<App
    prefetchPip={client.featureSwitches.prefetchPip}
    productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
  />);
});
